import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function MainSamplesMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { mainSampleList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingMS, setIsLoadingMS] = useState(false);
  const [showMS, setShowMS] = useState(false);
  const [isMainSampleUnique, setIsMainSampleUnique] = useState(true);
  const [buttonDownMs, setButtonDownMs] = useState(true);
  const [msBtnDisable, setMsBtnDisable] = useState(false);
  const [addingMS, setAddingMS] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isMS, setIsMS] = useState(false);
  const [mainSamplesData, setMainSamplesData] = useState([]);
  const [isUniqMainSampleId, setIsUniqMainSampleId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'samples', 'addEdit');
  useEffect(() => {
    setMainSamplesData(mainSampleList);
    if (addingMS) {
      setMainSamplesData([
        ...mainSampleList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [mainSampleList, addingMS]);

  const callApi = async () => {
    setButtonDownMs(!buttonDownMs);
    setIsLoadingMS(true);
    buttonDownMs ? setShowMS(true) : setShowMS(false);
    const msParams = {
      loggedInUserId,
    };
    isEmpty(mainSamplesData) && (await dispatch(action.getMainSampleDetails(msParams)));
    setIsLoadingMS(false);
  };

  const handleChanged = (event, i) => {
    const mainSamples = [...mainSamplesData];
    mainSamples[i] = {
      ...mainSamples[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    setIsMainSampleUnique(true);
    setIsUniqMainSampleId([]);
    const arr = [];
    const arrIndex = [];
    mainSamples.forEach((ele, ind) => {
      mainSamples.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqMainSampleId([...newArr]);
    }
    setIsMainSampleUnique(isEmpty(arr));
    let disableMs = false;
    mainSamples.forEach((mainSamplesElement) => {
      if (isEmpty(mainSamplesElement?.name?.trim())) {
        disableMs = true;
      }
    });
    setMsBtnDisable(disableMs);
    setMainSamplesData(mainSamples);
  };

  const addMs = async () => {
    if (!showMS) {
      setAddingMS(true);
      setButtonDownMs(!buttonDownMs);
      setIsLoadingMS(true);
      buttonDownMs ? setShowMS(true) : setShowMS(false);
      const msParams = {
        loggedInUserId,
      };
      isEmpty(mainSamplesData) && (await dispatch(action.getMainSampleDetails(msParams)));
      setIsLoadingMS(false);
    } else if (!isEmpty(mainSamplesData)) {
      setMainSamplesData([...mainSamplesData, tempObj]);
    } else {
      setMainSamplesData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      mainSamplesData.splice(id, 1);
      mainSamplesData.forEach((mainSamplesElement) => {
        if (isEmpty(mainSamplesElement?.name?.trim()) && mainSamplesElement.isNew) {
          setMsBtnDisable(true);
        } else {
          setMsBtnDisable(false);
        }
      });
      setIsMainSampleUnique(true);
      setIsUniqMainSampleId([]);
      setMainSamplesData([...mainSamplesData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveMs = async () => {
    setIsMS(true);
    if (!isEmpty(mainSamplesData)) {
      const emptyField = await mainSamplesData.filter((msitem) => msitem.name === null || msitem.name === '');

      if (isEmpty(emptyField)) {
        const data = mainSamplesData.map((msobj) => {
          return { ...msobj, name: msobj?.name?.trim() };
        });
        const mainSampleParams = {
          loggedInUserId,
          mainSamples: JSON.stringify(data),
          title: t('MAIN_SAMPLE_MASTER.MAIN_SAMPLE'),
        };
        setAddingMS(false);
        await dispatch(action.saveToSystemMaster(mainSampleParams, t));
        const msParams = {
          loggedInUserId,
        };
        await dispatch(action.getMainSampleDetails(msParams));
        // post API
      } else {
        const newState = mainSamplesData.map((msdobj) => (msdobj?.isEmpty === false && msdobj.name === null ? { ...msdobj, isEmpty: true } : msdobj));
        setMainSamplesData(newState);
      }
    }
    setIsMS(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    mainSamplesData.forEach((ele, index) => {
      mainSamplesData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsMainSampleUnique(isEmpty(array));
      setIsUniqMainSampleId([]);
    }
  }, [mainSamplesData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const mainSampelsParams = {
      loggedInUserId,
      mainSampleId: deleteId,
      title: t('MAIN_SAMPLE_MASTER.MAIN_SAMPLE'),
    };
    await dispatch(action.deleteFromSystemMasters(mainSampelsParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setMainSamplesData([...mainSampleList]);
    const msParams = {
      loggedInUserId,
    };
    await dispatch(action.getMainSampleDetails(msParams));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let ms = {};
    mainSamplesData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('MAIN_SAMPLE_MASTER.SAMPLE'),
        };
        ms = data;
      }
    });
    await dispatch(action.setActiveInactive(ms, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setMainSamplesData([...mainSamplesData]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingMS}
        setShow={showMS}
        callApi={callApi}
        buttonDown={buttonDownMs}
        mainData={mainSamplesData}
        handleChanged={handleChanged}
        addBtnClicked={addMs}
        deletPressed={handleDelete}
        onSave={saveMs}
        isDesabled={isMS}
        title={t('MAIN_SAMPLE_MASTER.MAIN_SAMPLES')}
        inputName="mainSamples"
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={msBtnDisable}
        isUnique={isMainSampleUnique}
        isUniqueId={isUniqMainSampleId}
        masterAddEditAccess={MasterAddEditAccess}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('MAIN_SAMPLE_MASTER.DELETE_FROM_SYSTEM_MASTER')}
          message={t('MAIN_SAMPLE_MASTER.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ITEM')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('MAIN_SAMPLE_MASTER.ACTIVATE_DEACTIVATE')}
          message={t('MAIN_SAMPLE_MASTER.ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE_DEACTIVATE_THIS_ITEM')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default MainSamplesMaster;
